export enum DataType {
    TEXT = 0,
    NUMBER = 1,
    DECIMAL = 2,
    DATE = 3,
    DATETIME = 4,
    TIME = 5,
    BUTTON = 6,
    OBJECT = 7,
    CHECKBOX = 8,
    CURRENCY = 9,
    HTML = 10,
    ADDRESS = 11,
    TAG_ON_OFF = 12,
    SWITCH = 13

}
